"use client";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useRouter } from "next/navigation";

function TrendingSearchTerms({
  trendingSearchTerms,
}: {
  trendingSearchTerms: { query: string }[];
}) {
  const t = useTranslations();

  return (
    <div className="mb-8 sm:mb-5">
      <p className="text-body-3 mb-1 text-grey-500">
        {t("search.trendingResults")}
      </p>
      <ul className="flex items-end flex-wrap mt-[10px] mb-5">
        {trendingSearchTerms.map(
          (term: { query: string }, termIndex: number) => (
            <Link
              href={`/search?q=${term.query}`}
              className="mr-2 mb-2 sm:mb-0 cursor-pointer"
              key={termIndex}
            >
              <div className="text-body-3 text-p-black py-1.5 px-3 bg-grey-100 rounded-full table hover:bg-black hover:text-white">
                {term.query}
              </div>
            </Link>
          ),
        )}
      </ul>
    </div>
  );
}

export default TrendingSearchTerms;
